import { showErrorMessage, hideErrorMessage } from './errorHandler'
import { calculateAge } from './helpers'

export function toggleRebateTier (form: HTMLFormElement) {
    const input = form.querySelector<HTMLInputElement>('[name="RebateTierId"]');
    const updateFormState = () => {
        const value = input.value;
        const rebatTierMessageContainer = form.querySelectorAll<HTMLElement>(`.rebate-tier`);

        rebatTierMessageContainer.forEach(htmlElement => {
            if (htmlElement.classList.contains(`rebate-tier-${value}`)) {
                htmlElement.classList.remove('hidden');
            } else {
                htmlElement.classList.add('hidden');
            }
        });
    };

    input.addEventListener("change", updateFormState);

    updateFormState();
}

export function toggleRebateDisclaimer (form: HTMLFormElement) {

    const input = form.querySelector<HTMLInputElement>('[name="RebateTierId"]');
    const updateFormState = () => {
        const rebatTierMessageContainer = form.querySelectorAll<HTMLElement>(`.rebate-tier-disclaimer`);

        rebatTierMessageContainer.forEach(htmlElement => {
            if (htmlElement.classList.contains(`hidden`)) {
                htmlElement.classList.remove('hidden');
            }
        });
    };

    input.addEventListener("change", updateFormState);
}

export function toggleRebateNext (form: HTMLFormElement) {
    const medicareElectronicRebateInputs = form.querySelectorAll<HTMLInputElement>(`[name="MedicareElectronicRebate"]`)
    const allEligibilInputs = form.querySelectorAll<HTMLInputElement>(`[name="AllEligibile"]`)
    const submitButton = form.querySelector<HTMLButtonElement>(`[type="submit"]`)

    const showSubmitButton = () => {
        submitButton.classList.remove('hidden');
    };
    const hideSubmitButton = () => {
        submitButton.classList.add('hidden');
    }

    const updateFormState = () => {
        const medicareElectronicRebateCheckedInput = [...medicareElectronicRebateInputs].filter((el) => el.checked).at(0);
        const isMediCareElectronicRebateNo = (medicareElectronicRebateCheckedInput && medicareElectronicRebateCheckedInput.value === "N");

        const allEligibleCheckedInput = [...allEligibilInputs].filter(el => el.checked).at(0);
        const isAllEligibleNo = (allEligibleCheckedInput && allEligibleCheckedInput.value === "N");

        if (medicareElectronicRebateCheckedInput === undefined) {
            // user has not selected whether to apply for rebate option yet
            showSubmitButton();
        } else if (isMediCareElectronicRebateNo) {
            // user has selected no to apply for rebate
            showSubmitButton();
        } else if (allEligibleCheckedInput === undefined) {
            // user has selected yes to apply for rebate, but hasn't made choice for all eligible yet
            showSubmitButton();
        } else if (isAllEligibleNo) {
            // user has selected yes to apply for rebate, but not everyone is eligible
            hideSubmitButton();
        } else {
            // user has selected yes to apply for rebate, and everyone is eligible
            showSubmitButton();
        }
    };

    [
        ...medicareElectronicRebateInputs,
        ...allEligibilInputs
    ].forEach((input) => input.addEventListener("change", updateFormState));

    updateFormState();
}

export function toggleMedicareCardColour (form: HTMLFormElement) {
    const input = form.querySelector<HTMLSelectElement>('[name="MedicareCardColour"]');
    const updateFormState = () => {
        const value = input.value;
        const messageContainer = form.querySelector<HTMLElement>(`.medicare-colour`);

        if (messageContainer.classList.contains(`medicare-colour-${value}`)) {
            messageContainer.classList.remove('hidden');
        } else {
            messageContainer.classList.add('hidden');
        }
    };

    input.addEventListener("change", updateFormState);

    updateFormState();
}

export function toggleAdb (form: HTMLFormElement) {
    const inputEvent = new Event('input');
    const abdEligibleContainer = form.querySelector('.abd.eligible');
    const abdNotEligibleContainer = form.querySelector('.abd.not-eligible');

    const updateFormState = () => {
        const ages: number[] = [];
        const now = Date.now();

        document.querySelectorAll('.dob-container:not(.hidden)').forEach((dobContainer) => {
            const dayElement = dobContainer.querySelector<HTMLInputElement>('[data-dob-type="day"]');
            const day = dayElement.value;
            const monthElement = dobContainer.querySelector<HTMLSelectElement>('[data-dob-type="month"]');
            const month = monthElement.value;
            const yearElement = dobContainer.querySelector<HTMLInputElement>('[data-dob-type="year"]');
            const year = yearElement.value;

            if (`${day}`.length > 0 && `${month}`.length == 2 && `${year}`.length == 4) {
                const dob = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

                if (dob.getTime() < now) {
                    ages.push(calculateAge(dob));
                }
            }
        });

        const adbEligibleAges = ages.filter((age) => age < 30);

        if (ages.length == 0) {
            abdEligibleContainer.classList.add('hidden');
            abdNotEligibleContainer.classList.add('hidden');
        } else if(adbEligibleAges.length > 0) {
            abdEligibleContainer.classList.remove('hidden');
            abdNotEligibleContainer.classList.add('hidden');
        } else {
            abdEligibleContainer.classList.add('hidden');
            // abdNotEligibleContainer.classList.remove('hidden');
        }
    };

    form.querySelectorAll('.dob-container input, .dob-container select').forEach(inputElement => {
        inputElement.addEventListener("input", updateFormState);

        inputElement.dispatchEvent(inputEvent);
    });
}

export function toggleOtherFields (form: HTMLFormElement) {
    const inputs = form.querySelectorAll<HTMLInputElement | HTMLSelectElement>("[data-toggle-other]");

    const isChecked = (input: HTMLInputElement | HTMLSelectElement) => {
        let ret = false;
        if (input.type === "radio") {
            ret = input.checked;
        } else if (input.getAttribute("data-toggle-if-value") !== null) {
            if (input.type === "checkbox") {
                ret = (input.getAttribute("data-toggle-if-unchecked") === "1")
                    ? !input.checked && input.value === input.getAttribute("data-toggle-if-value")
                    : input.checked && input.value === input.getAttribute("data-toggle-if-value");
            } else {
                ret = input.value === input.getAttribute("data-toggle-if-value");
            }
        } else if (input.getAttribute("data-toggle-if-not-value") !== null) {
            ret = input.value !== input.getAttribute("data-toggle-if-not-value");
        }

        return ret;
    }

    const resetRequiredInput = (input: HTMLInputElement | HTMLSelectElement) => {
        input.removeAttribute('required');
        hideErrorMessage(input);
        // input.value = '';
    }

    const updateFormState = () => {
        inputs.forEach((input) => {
            const isTargetVisible = isChecked(input);
            const otherInputContainers = form.querySelectorAll<HTMLElement>(`.${input.getAttribute("data-toggle-other")}`);
            otherInputContainers.forEach(otherInputContainer => {
                const otherInputs = otherInputContainer.querySelectorAll<HTMLInputElement | HTMLSelectElement>(`input, select`)

                if (isTargetVisible) {
                    otherInputContainer.classList.remove('hidden');
                    otherInputs.forEach(otherInput => {
                        if (otherInput.getAttribute("data-ignore-require") !== "1") {
                            if (otherInput.closest('.hidden') === null) {
                                otherInput.setAttribute("required", "required");
                            } else {
                                resetRequiredInput(otherInput);
                            }
                        }
                    });
                } else {
                    otherInputContainer.classList.add('hidden');
                    otherInputs.forEach(otherInput => resetRequiredInput(otherInput));
                }
            })
        });
    };

    form.querySelectorAll("input, select")?.forEach((elem) => {
        elem.addEventListener("change", updateFormState);
    });

    updateFormState();
}

export function toggleTransferFields (form: HTMLFormElement) {

    const updateFormState = () => {
        const transferFromAnotherFundValue = [...form.querySelectorAll<HTMLInputElement>('input[name="TransferFromAnotherFund"]')].filter(el => el.checked)[0]?.value;
        const isTransferFromAnotherFundValueY = transferFromAnotherFundValue === "Y";
        const transferFromAnotherFundPartnerValue = [...form.querySelectorAll<HTMLInputElement>('input[name="TransferFromAnotherFundPartner"]')].filter(el => el.checked)[0]?.value;
        const isTransferFromAnotherFundPartnerValueY = transferFromAnotherFundPartnerValue === "Y";

        const memberTip = form.querySelector<HTMLElement>('.transfer.member .tip');
        const memberInputWrapper = form.querySelector<HTMLElement>('.transfer.member.yes');
        const partnerSameDetailsWrapper = memberInputWrapper.querySelector<HTMLElement>('.transfer.partner.same');

        const partnerTip = form.querySelector<HTMLElement>('.transfer.partner .tip');
        const partnerInputWrapper = form.querySelector<HTMLElement>('.transfer.partner.yes');

        const joinReason = form.querySelector<HTMLElement>('.join-reason');
        const joinReasonSwitchLabel = joinReason.querySelector<HTMLLabelElement>('.switch');
        const joinReasonChooseLabel = joinReason.querySelector<HTMLLabelElement>('.choose');

        const hideElement = (el: HTMLElement) => {
            if (!el) {
                return;
            }
            el.classList.add('hidden');

            el.querySelectorAll('input, select').forEach((input) => {
                input.removeAttribute('required');
            })
        };
        const showElement = (el: HTMLElement) => {
            if (!el) {
                return;
            }
            el.classList.remove('hidden');

            el.querySelectorAll('input, select').forEach((input) => {
                if (input.getAttribute("data-ignore-require") !== "1") {
                    input.setAttribute('required', 'required');
                }
            })
        }

        const showSameDetails = (wrapper: HTMLElement) => {
            if (!wrapper) {
                return;
            }
            wrapper.classList.remove('hidden');
            wrapper.classList.add('flex');
        };

        const hideSameDetails = (wrapper: HTMLElement) => {
            if (!wrapper) {
                return;
            }
            wrapper.classList.add('hidden');
            wrapper.classList.remove('flex');
        }

        function membervalidation(memberid: string){
            document.getElementById(memberid).onkeyup = function(){
                const membershipIdInput = (document.getElementById(memberid) as HTMLInputElement)
                var membershipIdvalue = membershipIdInput.value;
                if(membershipIdvalue.length > 20 )
                {
                    showErrorMessage(membershipIdInput,"Please enter value lower or equal to 20 numbers")
                }else{
                    hideErrorMessage(membershipIdInput)
                }
            }
        }
        const varmembershipIdInput = (document.getElementById("MembershipId") as HTMLInputElement)

        if (isTransferFromAnotherFundValueY) {
            showElement(memberInputWrapper);

            if (isTransferFromAnotherFundPartnerValueY) {
                showSameDetails(partnerSameDetailsWrapper);
                hideElement(memberTip);
                showElement(partnerTip);
                membervalidation("MembershipId");
                membervalidation("PartnerMembershipId");
            } else {
                hideSameDetails(partnerSameDetailsWrapper);
                showElement(memberTip);
                hideElement(partnerTip);
                membervalidation("MembershipId");
            }
        } else {
            if (isTransferFromAnotherFundPartnerValueY){
                membervalidation("PartnerMembershipId");
                if(varmembershipIdInput)
                {
                    hideErrorMessage(varmembershipIdInput);
                }
            }
            hideElement(memberInputWrapper);
            hideElement(memberTip);
            hideSameDetails(partnerSameDetailsWrapper);
            if(varmembershipIdInput)
            {
                hideErrorMessage(varmembershipIdInput);
            }
        }

        const isSameDetailsWrapperHidden = (partnerSameDetailsWrapper)
            ? partnerSameDetailsWrapper.classList.contains('hidden')
            : true;
        const isSameDetailsY = !isSameDetailsWrapperHidden && [...partnerSameDetailsWrapper.querySelectorAll<HTMLInputElement>('input[name="PartnerSameDetails"]')].filter(el => el.checked)[0]?.value === "Y";
        const PartnerMembershipId = (document.getElementById("PartnerMembershipId") as HTMLInputElement)
        if (isTransferFromAnotherFundPartnerValueY && !isSameDetailsY) {
            showElement(partnerInputWrapper);

        } else {
            hideElement(partnerInputWrapper);
            if(PartnerMembershipId)
            {
                hideErrorMessage(PartnerMembershipId);
            }

        }


        let isAnyDependantTransferring = false;
        // Dependants Yes/No choice
        form.querySelectorAll('.transfer.dependant.choices')
            .forEach(elem=>{

                const isTransferring = [...elem.querySelectorAll("input")].filter(el=> el.checked)[0]?.value === "Y";
                const dependantId = elem.dataset.dependantId;

                const fundDetailsWrapper = form.querySelector(`#wrapper-${dependantId}`);
                const tipElement = elem.querySelector('.tip');
                const sameWrapper = form.querySelector(`#wrapper-dependant-same-details-${dependantId}`);
                const isTheSameFromMainMember = sameWrapper?.querySelector("input")?.checked;
                const DependantMembershipId = (document.getElementById(`DependantMembershipId-${dependantId}`) as HTMLInputElement)

                if(isTransferring){
                    if(isTransferFromAnotherFundValueY && isTheSameFromMainMember){
                        hideElement(fundDetailsWrapper);
                        hideErrorMessage(DependantMembershipId);
                    }
                    else{
                        showElement(fundDetailsWrapper);
                        membervalidation(`DependantMembershipId-${dependantId}`);
                    }

                    showElement(tipElement);
                    showSameDetails(sameWrapper);
                    isAnyDependantTransferring = true;
                }
                else{
                    hideElement(fundDetailsWrapper);
                    hideElement(tipElement);
                    hideSameDetails(sameWrapper);
                }

            });

        // Join Reason
        const isTransferringSelected = (!!transferFromAnotherFundValue && partnerTip === null) ||
            (!!transferFromAnotherFundValue && partnerTip !== null && !!transferFromAnotherFundPartnerValue);
        const isYSelected = isTransferFromAnotherFundValueY || isTransferFromAnotherFundPartnerValueY || isAnyDependantTransferring;
        if (isTransferringSelected) {
            showElement(joinReason);

            if(isYSelected) {
                showElement(joinReasonSwitchLabel);
                hideElement(joinReasonChooseLabel);
            } else {
                hideElement(joinReasonSwitchLabel);
                showElement(joinReasonChooseLabel);
            }
        } else {
            hideElement(joinReason);
        }
    }

    form.querySelectorAll('input[name="TransferFromAnotherFund"], input[name="TransferFromAnotherFundPartner"], input[name="PartnerSameDetails"], input.TransferFromAnotherFundDependant, input.DependantSameDetails')?.forEach((elem) => {
        elem.addEventListener("change", updateFormState);
    });

    updateFormState();
}

export function togglePaymentFrequency (form: HTMLFormElement) {
    const updateFormState = () => {
        const selectInput = form.querySelector('#DeductionBillingGroupId') as HTMLSelectElement;
        const selectContainer = selectInput.closest('.deduction-container') as HTMLElement;

        const selectedOption = selectInput.querySelector('option:checked').innerHTML.trim();
        const selectedOptionClass = `deduction-message-${selectedOption.replace(/\s/g, '-').replace(/[^\w-]/g, '')}`

        selectContainer.querySelectorAll('.selection-note').forEach((el) => {
            if (el.classList.contains(selectedOptionClass)) {
                el.classList.remove('hidden');
            } else {
                el.classList.add('hidden');
            }
        });
    }

    form.querySelectorAll("#DeductionBillingGroupId")?.forEach((elem) => {
        elem.addEventListener("change", updateFormState);
    });

    updateFormState();
}